import React from 'react';

function IdentityPanel({ personal, onExplore }) {
  return (
    <aside className="identity-panel" aria-labelledby="identity-name">
      <div className="identity-panel__intro">
        <p className="eyebrow">Portfolio</p>
        <h1 id="identity-name">{personal.name}</h1>
        <p className="identity-panel__role">{personal.title}</p>
        <p className="identity-panel__thesis">
          I turn limited or messy data into tested models and usable tools.
        </p>
      </div>

      <button
        className="flagship-card"
        type="button"
        onClick={() => onExplore('Tell me about FluxTrade', 'fluxtrade')}
      >
        <span className="flagship-card__label">Featured project</span>
        <strong>Rust + Python trading systems</strong>
        <span>Building · Rust + Python</span>
      </button>
    </aside>
  );
}

export default IdentityPanel;
